import { ensureModelContext } from "./modelContext";
import { registerConsulenzaTools } from "./consulenzaTools";
import { registerNewsTools } from "./newsTools";
import { registerRicercatoreTools } from "./tools";
import { graphql, useStaticQuery } from "gatsby";
import { useEffect } from "react";

/**
 * Registra una sola volta, a livello applicativo, i tool WebMCP del sito
 * (RicercatoreMutuo + news). Va montato una volta sola vicino alla radice
 * dell'app (vedi gatsby-browser wrapRootElement). Non renderizza nulla.
 *
 * NB: aggiungendo/rinominando un tool aggiornare anche il manifest di discovery
 * static/.well-known/webmcp.json (nome + descrizione).
 */
export default function WebMcpTools() {
  const data = useStaticQuery(graphql`
    query {
      allWpPost(sort: { date: DESC }) {
        nodes {
          title
          uri
          date
          acfArticolo {
            titoloUltimeNews
            estratto
          }
          tags {
            nodes {
              name
              slug
            }
          }
        }
      }
      allWpRassegna(sort: { date: DESC }) {
        nodes {
          title
          uri
          date
          acfRassegna {
            estratto
          }
        }
      }
      allWpTag(filter: { count: { gt: 0 } }) {
        nodes {
          name
          slug
          uri
          count
        }
      }
    }
  `);

  useEffect(() => {
    const modelContext = ensureModelContext();
    if (!modelContext) return undefined;

    const unregisterRicercatore = registerRicercatoreTools(modelContext);
    const unregisterNews = registerNewsTools(modelContext, {
      posts: data.allWpPost?.nodes || [],
      rassegne: data.allWpRassegna?.nodes || [],
      tags: data.allWpTag?.nodes || [],
    });
    const unregisterConsulenza = registerConsulenzaTools(modelContext);

    return () => {
      unregisterRicercatore();
      unregisterNews();
      unregisterConsulenza();
    };
  }, []);

  return null;
}
